import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { DeploymentTargetResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { Select } from "~/components/form";
import type { DropdownMenuOption } from "~/primitiveComponents/form/Select/DropDownMenu";
type KubernetesAgentSelectionPageProps = {
    agents: DeploymentTargetResource[];
    selectedAgent: string | undefined;
    onSelectionChanged: (newValue: string | undefined) => void;
};
export function KubernetesAgentSelectionPage({ agents, selectedAgent, onSelectionChanged }: KubernetesAgentSelectionPageProps) {
    const items: DropdownMenuOption[] = agents.map((agent) => ({
        value: agent.Name,
        text: agent.Name,
    }));
    return (<div className={styles.content}>
            <div>
                <p className={styles.paragraphWithSpace}>
                    To start getting live status, you'll need to upgrade your Kubernetes agents to support the Octopus Kubernetes Monitor. <ExternalLink size="base" href={"UpgradeKubernetesMonitor"} label={"Read the docs"}/>
                </p>
                <p>Select an upgradeable agent below and we'll generate a custom Helm command for it.</p>
            </div>
            <Select label={"Kubernetes agent"} items={items} value={selectedAgent} onChange={onSelectionChanged}/>
        </div>);
}
const styles = {
    content: css({ display: "flex", flexDirection: "column", gap: space[16] }),
    paragraphWithSpace: css({ paddingBottom: space[16] }),
};
